import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '400px',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '80px auto',
    [theme.breakpoints.only('xs')]: {
      margin: '60px auto',
    },
  },
  text: {
    textAlign: 'center',
    margin: '5px',
  },
  link: {
    textDecoration: 'underline',
    fontSize: '16px',
    color: theme.palette.secondary.main,
    fontWeight: '600',
  },
  subtitle: {
    maxWidth: '588px',
    textAlign: 'center',
  },
  searchIcon: {
    '&.MuiIconButton-root.Mui-disabled': {
      background: '#E1F5FE',
      padding: theme.spacing(5),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
    },
  },
  pagination: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: '0',
      width: '100%',
      padding: '12px 0px',
      backgroundColor: 'white',
    },
  },
  paginationHeader: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      backgroundColor: 'white',
    },
  },
  mapViewListWrapper: ({ showRefiners }) => ({
    overflowY: 'scroll',
    scrollBehavior: 'smooth',
    maxHeight: showRefiners ? 'calc(100vh - 280px)' : 'calc(100vh - 190px)',
    [theme.breakpoints.up('md')]: {
      maxHeight: 'calc(100vh - 320px)',
      marginTop: '0px',
    },
  }),
}))

export default useStyles
